"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7657],{

/***/ 78516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 6rem;\n  border-radius: ",
        "px;\n  outline: none;\n  border: none;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  &.btn__primary {\n    background: ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__primary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n  }\n  &.btn__secondary {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__secondary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonComponent = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonComponent",
    componentId: "sc-7bbccc7b-0"
})(_templateObject(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.roundness) || 0;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundHoverColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js



var Button = function(props) {
    var ref, ref1, ref2;
    return (props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.btnText) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, {
        className: "btn__".concat(props === null || props === void 0 ? void 0 : (ref1 = props.btnData) === null || ref1 === void 0 ? void 0 : ref1.type),
        primaryButton: props === null || props === void 0 ? void 0 : props.primaryButton,
        secondaryButton: props === null || props === void 0 ? void 0 : props.secondaryButton,
        onClick: function() {
            var ref;
            (0,btnUtils/* btnActionHandler */.c)(props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.actions, props === null || props === void 0 ? void 0 : props.callback);
            (props === null || props === void 0 ? void 0 : props.handleClose) && (props === null || props === void 0 ? void 0 : props.handleClose());
        },
        children: props === null || props === void 0 ? void 0 : (ref2 = props.btnData) === null || ref2 === void 0 ? void 0 : ref2.btnText
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Button_Button = (Button);


/***/ }),

/***/ 458252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var Description = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        onClick: function(e) {
            var ref, ref1, ref2;
            e.stopPropagation();
            props === null || props === void 0 ? void 0 : (ref = props.handleEditText) === null || ref === void 0 ? void 0 : ref.call(props);
            props === null || props === void 0 ? void 0 : (ref2 = props.getInputPreFilledValue) === null || ref2 === void 0 ? void 0 : ref2.call(props, (ref1 = props.descriptionData) === null || ref1 === void 0 ? void 0 : ref1.text);
        },
        className: "Description",
        children: (ref = props.descriptionData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Description);


/***/ }),

/***/ 192578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var Heading = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "Heading",
        children: props === null || props === void 0 ? void 0 : (ref = props.headingData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 737657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ModernMiddleBody3_ModernMiddleBody3; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Heading/Heading.js
var Heading = __webpack_require__(192578);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Description/Description.js
var Description = __webpack_require__(458252);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js + 1 modules
var Button = __webpack_require__(78516);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/ImageSlider/ImageSlider.js + 2 modules
var ImageSlider = __webpack_require__(131337);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(737179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(842757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(926601);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(720901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Tabs/ModernMiddleBody3/ModernMiddleBody3.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0; /* Set the z-index behind other content */\n  }\n  /* Add a linear gradient overlay */\n  &::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    opacity: ",
        ";\n  }\n  @media screen and (min-width: 768px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  & > video {\n    position: absolute;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n  }\n\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: 768px) {\n    padding: 4rem;\n    gap: 4rem;\n  }\n  @media screen and (max-width: 767px) {\n    padding: 2rem 0rem;\n    gap: 2.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  @media screen and (min-width: 768px) {\n    gap: 4rem;\n  }\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  & > h1 {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    color: ",
        ";\n    font-family: ",
        ";\n    text-align: ",
        ";\n  }\n  & > p {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    font-style: normal;\n    color: ",
        ";\n    text-align: ",
        ";\n    font-family: ",
        ";\n    opacity: ",
        ";\n    margin: 0;\n  }\n  @media screen and (min-width: 768px) {\n    & > h1 {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 3.875rem;\n      align-self: flex-start;\n      width: 100%;\n    }\n    & > p {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 1.75rem;\n      align-self: flex-start;\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > h1 {\n      font-size: 1.5rem;\n      font-weight: 700;\n      line-height: normal;\n      width: 100%;\n      align-self: center;\n    }\n    & > p {\n      font-size: 0.875rem;\n      font-weight: 400;\n      line-height: normal;\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* min-width: max-content; */\n  display: flex;\n  flex-wrap: wrap;\n  align-self: center;\n  @media screen and (min-width: 768px) {\n    align-self: center;\n  }\n  @media screen and (max-width: 767px) {\n    align-self: flex-start;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n  flex-wrap: wrap;\n  @media screen and (max-width: 767px) {\n    justify-content: center;\n    flex-direction: column;\n    width: 100%;\n    button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  overflow-x: auto;\n  border-bottom: ",
        ";\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  /* opacity: 0.1; */\n  & div {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n  }\n  & div > .nav-link-text {\n    flex: 0;\n    width: 100%;\n    padding: 0.875rem 1rem;\n    min-width: fit-content;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n    cursor: pointer;\n    overflow-y: hidden;\n  }\n  & .nav-link-text > .bar {\n    position: absolute;\n    border: 2.5px solid ",
        ";\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    bottom: -2px;\n    right: 0;\n    width: 100%;\n  }\n  & .nav-link-text > .bar.hidden {\n    display: none;\n  }\n  & .nav-link-text > .bar.active {\n    display: block;\n  }\n  @media screen and (max-width: 767px) {\n    & div {\n      justify-content: flex-start;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .slider__parent {\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 4rem;\n    @media screen and (max-width: 767px) {\n      gap: 0.75rem;\n    }\n  }\n  & > .slider__parent > .arrow-group {\n    align-self: flex-end;\n    gap: 17px;\n  }\n  & > .slider__parent > .arrow-group > button {\n    padding: 1rem;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    @media screen and (max-width: 767px) {\n      padding: 0.556rem;\n    }\n  }\n  & > .slider__parent > .arrow-group > .tab3_next {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n  & > .slider__parent > .arrow-group > .tab3_next:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n  & > .slider__parent > .arrow-group > .tab3_prev {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n  & > .slider__parent > .arrow-group > .tab3_prev:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n  & > .slider__parent,\n  & > .slider__parent > .slick-slider,\n  & > .slider__parent > .slick-slider > .slick-list,\n  & > .slider__parent > .slick-slider > .slick-list > .slick-track,\n  & > .slider__parent > .slick-slider > .slick-list > .slick-track > .slick-slide,\n  & > .slider__parent > .slick-slider > .slick-list > .slick-track > .slick-slide > div,\n  &\n    > .slider__parent\n    > .slick-slider\n    > .slick-list\n    > .slick-track\n    > .slick-slide\n    > div\n    > .slider-media,\n  &\n    > .slider__parent\n    > .slick-slider\n    > .slick-list\n    > .slick-track\n    > .slick-slide\n    > div\n    > .slider-media\n    > .slide-image-container,\n  &\n    > .slider__parent\n    > .slick-slider\n    > .slick-list\n    > .slick-track\n    > .slick-slide\n    > div\n    > .slider-media\n    > .slide-image-container\n    > img {\n    height: 100% !important;\n    aspect-ratio: 16 / 9 !important;\n  }\n  .modern_theme_middlebodytab3\n    .tab-bottom\n    .nav-content\n    > .tab-bottom\n    > .slider__parent\n    > .slick-slider\n    .slick-dots {\n    display: none !important;\n  }\n  @media screen and (min-width: 768px) {\n    padding: 0rem;\n  }\n  @media screen and (max-width: 767px) {\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var MiddleBodyVideoBackground = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(props) {
    var ref, ref1;
    return !((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) && "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx);
var MiddleBodyParent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), function(props) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
});
var BannerContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var TopContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var TopLeftSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});
var TopRightSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5());
var BottomContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
var ButtonContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7());
var NavContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8(), function(props) {
    var ref, ref1;
    return props.isNavItem ? "1px solid ".concat((0,utils_common/* hexToRgba */.a7)("".concat(props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.nav) === null || ref1 === void 0 ? void 0 : ref1.color), utils_common/* TAB_BAR_OPACITY */.oU)) : "0px";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.nav) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.nav) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var NavContent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject9(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.borderColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.propStyle) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var actions_common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Tabs/ModernMiddleBody3/ModernMiddleBody3.js












function ModernMiddleBody3(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), middleBodyState = ref24[0], setMiddleBodyState = ref24[1];
    var ref25 = (0,react.useState)({
        navLink: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref1 = middleBodyState.navContent) === null || ref1 === void 0 ? void 0 : ref1.content) ? (ref3 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref2 = middleBodyState.navContent) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.navText : "",
        navContent: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref4 = middleBodyState.navContent) === null || ref4 === void 0 ? void 0 : ref4.content) ? (ref6 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref5 = middleBodyState.navContent) === null || ref5 === void 0 ? void 0 : ref5.content[0]) === null || ref6 === void 0 ? void 0 : ref6.content : {},
        navId: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref7 = middleBodyState.navContent) === null || ref7 === void 0 ? void 0 : ref7.content) ? (ref9 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref8 = middleBodyState.navContent) === null || ref8 === void 0 ? void 0 : ref8.content[0]) === null || ref9 === void 0 ? void 0 : ref9.id : ""
    }), activeLink = ref25[0], setActiveLink = ref25[1];
    var linkRefs = Array.from({
        length: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref10 = middleBodyState.navContent) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.content) === null || ref11 === void 0 ? void 0 : ref11.length
    }).map(function() {
        return /*#__PURE__*/ (0,react.createRef)(null);
    });
    var ref26 = (0,react.useState)({
        config: {
            bannerAspectRatio: {
                desktop: 768,
                mobile: 768
            },
            rotationSpeed: 3
        }
    }), styleConfig = ref26[0];
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref27 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref12 = storeData.theme) === null || ref12 === void 0 ? void 0 : ref12.style_template), propStyle = ref27[0], setPropStyle = ref27[1];
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children) {
            var ref1;
            setMiddleBodyState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.children));
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref13 = props.config) === null || ref13 === void 0 ? void 0 : ref13.children
    ]);
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref14 = storeData.theme) === null || ref14 === void 0 ? void 0 : ref14.style_template
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var openForm = function() {
        dispatch((0,actions_common/* toggleFormWidget */.Aq)(true));
    };
    (0,react.useEffect)(function() {
        var video = document.querySelector("video");
        if (video) {
            video.setAttribute("playsinline", "");
        }
    }, []);
    // const handleNavClick = (navText,navContent) => setActiveLink((prevLink)=>(navText.length&&navContent?({navLink:navText,navContent:navContent}):{...prevLink}));
    var handleNavClick = function(navText, navContent, index, navId) {
        linkRefs[index].current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
        setActiveLink({
            navLink: navText.length && navContent ? navText : activeLink.navLink,
            navContent: navContent ? navContent : activeLink.navContent,
            navId: navId ? navId : activeLink === null || activeLink === void 0 ? void 0 : activeLink.navId
        });
    };
    var renderParentContainer = function(bgType) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContainer, {
                    children: [
                        ((middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.heading) === null || ref === void 0 ? void 0 : ref.text) || (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref1 = middleBodyState.description) === null || ref1 === void 0 ? void 0 : ref1.text)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopLeftSection, {
                            textStyles: propStyle,
                            children: [
                                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref2 = middleBodyState.heading) === null || ref2 === void 0 ? void 0 : ref2.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    headingData: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.heading
                                }),
                                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref3 = middleBodyState.description) === null || ref3 === void 0 ? void 0 : ref3.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                    descriptionData: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.description
                                })
                            ]
                        }),
                        (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref4 = middleBodyState.button) === null || ref4 === void 0 ? void 0 : ref4.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRightSection, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                children: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref5 = middleBodyState.button) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.content) === null || ref6 === void 0 ? void 0 : ref6.map(function(btnData, idx) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.button) === null || ref === void 0 ? void 0 : ref.type,
                                        btnData: btnData,
                                        primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                                        secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                                        callback: openForm
                                    }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
                                })
                            })
                        })
                    ]
                }),
                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref7 = middleBodyState.navContent) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.content) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomContainer, {
                    className: "tab-bottom",
                    children: [
                        (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref9 = middleBodyState.navContent) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.content) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavContainer, {
                            textStyles: propStyle,
                            isNavItem: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref11 = middleBodyState.navContent) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.content) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 ? true : false,
                            children: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref13 = middleBodyState.navContent) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.content) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "nav-links",
                                children: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref15 = middleBodyState.navContent) === null || ref15 === void 0 ? void 0 : ref15.content.map(function(navData, idx) {
                                    var ref;
                                    return (navData === null || navData === void 0 ? void 0 : (ref = navData.navText) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "nav-link-text",
                                        onClick: function() {
                                            return handleNavClick(navData === null || navData === void 0 ? void 0 : navData.navText, navData === null || navData === void 0 ? void 0 : navData.content, idx, navData === null || navData === void 0 ? void 0 : navData.id);
                                        },
                                        ref: linkRefs[idx],
                                        children: [
                                            navData === null || navData === void 0 ? void 0 : navData.navText,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bar ".concat((activeLink === null || activeLink === void 0 ? void 0 : activeLink.navId) === (navData === null || navData === void 0 ? void 0 : navData.id) ? "active" : "hidden")
                                            })
                                        ]
                                    }, navData === null || navData === void 0 ? void 0 : navData.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                })
                            }) : null
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavContent, {
                            className: "nav-content",
                            propStyle: propStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                mediaContent: ((ref17 = (0,common/* transformWidgetProps */.Ak)(activeLink === null || activeLink === void 0 ? void 0 : (ref16 = activeLink.navContent) === null || ref16 === void 0 ? void 0 : ref16.children)) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.media) === null || ref18 === void 0 ? void 0 : ref18.foreground) || [],
                                hideDots: "hide",
                                usedIn: "tab3"
                            }, activeLink === null || activeLink === void 0 ? void 0 : activeLink.navLink)
                        })
                    ]
                })
            ]
        });
    };
    return (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref15 = middleBodyState.background) === null || ref15 === void 0 ? void 0 : ref15.type) === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyVideoBackground, {
        id: "MT__MIDDLEBODY3",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebodytab3 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref16 = middleBodyState.media) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.background) === null || ref17 === void 0 ? void 0 : ref17.type),
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                onError: function(e) {
                    var ref, ref1, ref2;
                    return e.target.src = (ref2 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.content[0]) === null || ref2 === void 0 ? void 0 : ref2.url;
                },
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: (ref20 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref18 = middleBodyState.media) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.background) === null || ref19 === void 0 ? void 0 : ref19.content[0]) === null || ref20 === void 0 ? void 0 : ref20.url,
                    type: "video/mp4"
                })
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContainer, {
                children: [
                    " ",
                    renderParentContainer("video"),
                    " "
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBodyParent, {
        id: "MT__MIDDLEBODY3",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        propsBackground: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref21 = middleBodyState.media) === null || ref21 === void 0 ? void 0 : ref21.background,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebodytab3 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref22 = middleBodyState.media) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.background) === null || ref23 === void 0 ? void 0 : ref23.type),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContainer, {
            children: [
                " ",
                renderParentContainer("")
            ]
        })
    });
}
/* harmony default export */ var ModernMiddleBody3_ModernMiddleBody3 = (ModernMiddleBody3);


/***/ })

}]);